import React from 'react';
import { useTranslation } from 'react-i18next';
import { UtpCardSection } from 'common/components';
import { BATHROOM_REPAIR_CDN_PATH, BATHROOM_REPAIR_ELEMENT_BLOCK } from '../../bathroom-repair-constants';
import { FreeProjectModal, GuaranteeModal, OneMonthModal, OneTeamModal } from './components';

type BathroomRepairUtpCardSectionProps = {
  regionId: string;
};

export const BathroomRepairUtpCardSection = ({ regionId }: BathroomRepairUtpCardSectionProps) => {
  const { t } = useTranslation();

  return (
    <UtpCardSection
      elementBlock={BATHROOM_REPAIR_ELEMENT_BLOCK}
      elementText={t('utp-section.title')}
      renderModalContent={({ modal: { content: ModalContent } = {} }) => ModalContent && <ModalContent regionId={regionId} />}
      title={t('utp-section.title') || ''}
      utpCardList={[
        {
          elementName: t('utp-section.free-project.card-title'),
          header: {
            title: t('utp-section.free-project.card-title'),
            mobileTitle: t('utp-section.free-project.card-mobile-title') || '',
          },
          description: {
            text: t('utp-section.free-project.card-description'),
          },
          image: {
            alt: t('utp-section.free-project.card-title'),
            src: `${BATHROOM_REPAIR_CDN_PATH}/utp/free-project.png/free-project-01.png`,
          },
          modal: { content: FreeProjectModal },
        },
        {
          elementName: t('utp-section.one-team.card-title'),
          header: {
            title: t('utp-section.one-team.card-title'),
          },
          description: {
            text: t('utp-section.one-team.card-description'),
          },
          image: {
            alt: t('utp-section.one-team.card-title'),
            src: `${BATHROOM_REPAIR_CDN_PATH}/utp/one-team.png/one-team-01.png`,
          },
          modal: { content: OneTeamModal },
        },
        {
          elementName: t('utp-section.one-month.card-title'),
          header: {
            title: t('utp-section.one-month.card-title'),
          },
          description: {
            text: t('utp-section.one-month.card-description'),
          },
          image: {
            alt: t('utp-section.one-month.card-title'),
            src: `${BATHROOM_REPAIR_CDN_PATH}/utp/one-month.png/one-month.png`,
          },
          modal: { content: OneMonthModal },
        },
        {
          elementName: t('utp-section.guarantee.card-title'),
          header: {
            title: t('utp-section.guarantee.card-title'),
          },
          description: {
            text: t('utp-section.guarantee.card-description'),
          },
          image: {
            alt: t('utp-section.guarantee.card-title'),
            src: `${BATHROOM_REPAIR_CDN_PATH}/utp/guarantee.png/guarantee-01.png`,
          },
          modal: { content: GuaranteeModal },
        },
      ]}
    />
  );
};
